import { render, staticRenderFns } from "./ImportGenericDialog.vue?vue&type=template&id=787b12ca"
import script from "./ImportGenericDialog.vue?vue&type=script&lang=js"
export * from "./ImportGenericDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports